//natives
import React, { Component } from "react";
import Cookies from "universal-cookie";
// import TagManager from 'react-gtm-module';

//components
import Alerta from "../../../../../util/snackbars/.mixins/";
import Section from "../childrens/Section/.mixins/Section";
import Modal_Remove from "../../../../../util/modal_remove/.mixins/Modal_Remove";

//constrollers
import Config from "../../../../../../controllers/config";
import ConfiguraOpcoesRecebimentoController from "../../../../../../controllers/opcoesRecebimentoGrupo";
import Log from "../../../../../../controllers/log";

export default class GrupoOpcoesRecebimento_ae extends Component {
    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();
        this.modelRef = React.createRef();

        this.state = {
            nm_org: "",
            tx_obs: "",
            tipo: "Adicionar",
            openModalDelete: false,
            flagDelete: true,
            isLoading: false,
            oneClick: false,
        };

        if (this.props && this.props.params && this.props.params.id) {
            this.state.tipo = "Editar";
            this.state.isLoading = true;
            this.carregarDados();
        }

        this.setState = this.setState.bind(this);
        this.validacao = this.validacao.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:grupo-opcoes-recebimento',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-grupo-opcoes-recebimento',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get("User-Token");
        Log.info(token, "Efetuado carregamento da tela forumulário de grupos!");
    }

    handleClickOpen = () => {
        this.setState({ openModalDelete: true });
    };

    handleClose = () => {
        this.setState({ openModalDelete: false });
    };

    async carregarDados() {
        //instancia cookies e captura user-token para fazer request
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        try {
            //recupera dados de grupos
            const r_grupo = await ConfiguraOpcoesRecebimentoController.getById(
                token,
                this.props.params.id
            );

            //convert dados de grupos para object
            const j_r_grupo = JSON.parse(r_grupo.body);

            //valida resultado da consulta
            if (this.child.current != null) {
                if (r_grupo.res.statusCode == 200) {
                    this.setState({
                        nm_org: j_r_grupo.nm_org,
                        isLoading: false,
                    });

                    // TagManager.dataLayer({
                    //     dataLayer: {
                    //       event: 'event',
                    //       eventCategory: 'tokstok:fornecedores:grupos-opcoes-recebimento',
                    //       eventAction: 'callback',
                    //       eventLabel: `sucesso:opcao-recebimento-${this.props.params.id}`,
                    //     }
                    // });
                } else if (j_r_grupo.message === "Token inválido!") {
                    this.child.current.retorno("Autentificação inválida!", "error");
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                } else {
                    this.child.current.retorno("Não foi possível carregador os dados!", "error");
                }
            }
        } catch (error) {
            if (this.child.current != null) {
                this.child.current.retorno("Erro na recuperação de dados de grupo!", "error");
            }

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:grupos-opcoes-recebimento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            const str = `Erro na recuperação de dados de grupo! 
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.error(token, str);
        }
    }

    async validacao() {
        if (this.state.nm_org === "" && this.child.current != null) {
            return this.child.current.retorno("Preencha o campo descrição!", "warning");
        }

        this.setState({ oneClick: true });
        let falha = 0;
        const cookies = new Cookies();

        //verificar tipo do metodo
        var params = null;
        if (this.state.tipo === "Adicionar") {
            params = {
                method: "post",
                url: "/grupoOpcoesRecebimento/",
            };
        } else {
            params = {
                method: "put",
                url: `/grupoOpcoesRecebimento/${this.props.params.id}`,
            };
        }

        let retorno = null;

        await fetch(Config.URL_BACKEND + params.url, {
            method: params.method,
            headers: {
                "Content-Type": "application/json",
                "User-Token": cookies.get("User-Token"),
            },
            body: JSON.stringify(this.state),
        })
            .then(function (a) {
                return a.json();
            })
            .then(function (json) {
                retorno = json;

                if (json.status) {
                    falha = 0;
                } else if (json.message === "Token inválido!") {
                    falha = 2;
                } else {
                    falha = 1;
                }
            });
        //TODO Ainda não entendi o pq precisa ser fora..... validar
        const props = this;
        if (this.child.current != null) {
            if (falha === 0) {
                this.child.current.retorno(retorno.message, "success");

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:grupos-opcoes-recebimento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:opcao-recebimento-${retorno.message}`,
                //     }
                // });

                setTimeout(function () {
                    props.props.router.goBack();
                }, 1000);
            } else if (falha === 1) {
                this.child.current.retorno(
                    `Não foi possível criar um novo ${this.props.route.title}!`,
                    "error"
                );
                this.setState({ oneClick: false });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:grupos-opcoes-recebimento',
                //       eventAction: 'callback',
                //       eventLabel: `erro:falha-criação-${this.props.route.title}`,
                //     }
                // });
            } else if (falha === 2) {
                this.child.current.retorno(
                    `Não foi possível criar um novo ${this.props.route.title}!`,
                    "error"
                );
                setTimeout(function () {
                    props.props.router.goBack();
                }, 2000);
            }
        }
    }

    render() {
        return (
            <div>
                <Section ref={this.inputRef} {...this} />
                <Alerta ref={this.child} />
                <Modal_Remove pai={this} ref={this.modelRef} />
            </div>
        );
    }
}
